import { useState, useEffect } from "react";

const API = "https://scraps-backend.onrender.com";
const FONT = `@import url('https://fonts.googleapis.com/css2?family=Barlow+Condensed:wght@700;800;900&family=Inter:wght@400;500;600;700;800&display=swap');`;

const ALL_SPORTS = [
  { key:"americanfootball_nfl", label:"NFL", emoji:"🏈", group:"American Football" },
  { key:"americanfootball_ncaaf", label:"College Football", emoji:"🏈", group:"American Football" },
  { key:"basketball_nba", label:"NBA", emoji:"🏀", group:"Basketball" },
  { key:"basketball_ncaab", label:"College Basketball", emoji:"🏀", group:"Basketball" },
  { key:"basketball_wnba", label:"WNBA", emoji:"🏀", group:"Basketball" },
  { key:"baseball_mlb", label:"MLB", emoji:"⚾", group:"Baseball" },
  { key:"icehockey_nhl", label:"NHL", emoji:"🏒", group:"Hockey" },
  { key:"soccer_epl", label:"EPL", emoji:"⚽", group:"Soccer" },
  { key:"soccer_uefa_champs_league", label:"Champions League", emoji:"⚽", group:"Soccer" },
  { key:"soccer_usa_mls", label:"MLS", emoji:"⚽", group:"Soccer" },
  { key:"soccer_germany_bundesliga", label:"Bundesliga", emoji:"⚽", group:"Soccer" },
  { key:"soccer_spain_la_liga", label:"La Liga", emoji:"⚽", group:"Soccer" },
  { key:"soccer_italy_serie_a", label:"Serie A", emoji:"⚽", group:"Soccer" },
  { key:"soccer_france_ligue_one", label:"Ligue 1", emoji:"⚽", group:"Soccer" },
  { key:"tennis_atp_french_open", label:"Tennis", emoji:"🎾", group:"Other" },
  { key:"mma_mixed_martial_arts", label:"MMA / UFC", emoji:"🥊", group:"Other" },
  { key:"golf_pga_tour", label:"Golf (PGA)", emoji:"⛳", group:"Other" },
  { key:"motorsport_formula_1", label:"NASCAR / F1", emoji:"🏎", group:"Other" },
];

function StatCard({ label, value, accent }) {
  return (
    <div style={{ background:"#fff", border:"1px solid #f3f4f6", borderRadius:12, padding:"14px 16px", boxShadow:"0 1px 3px rgba(0,0,0,0.06)" }}>
      <div style={{ fontSize:10, fontWeight:600, color:"#9ca3af", letterSpacing:"0.04em", marginBottom:6, fontFamily:"'Inter',sans-serif" }}>{label.toUpperCase()}</div>
      <div style={{ fontSize:24, fontWeight:800, color:accent||"#111827", fontFamily:"'Inter',sans-serif" }}>{value}</div>
    </div>
  );
}

function MemberModal({ leagueId, leagueName, token, onClose }) {
  const [members, setMembers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API}/superadmin/leagues/${leagueId}/members`, { headers:{ Authorization:`Bearer ${token}` } })
      .then(r=>r.json()).then(d=>{ setMembers(d); setLoading(false); });
  }, [leagueId]);

  const removePlayer = async (m) => {
    if (!window.confirm(`Remove ${m.team_name} from ${leagueName}?`)) return;
    await fetch(`${API}/superadmin/leagues/${leagueId}/remove-player/${m.id}`, { method:"DELETE", headers:{ Authorization:`Bearer ${token}` } });
    const res = await fetch(`${API}/superadmin/leagues/${leagueId}/members`, { headers:{ Authorization:`Bearer ${token}` } });
    setMembers(await res.json());
  };

  const sorted = [...members].sort((a,b)=>(a.owner_name||"").localeCompare(b.owner_name||""));

  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:200, padding:20 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:"#fff", borderRadius:16, padding:28, maxWidth:680, width:"100%", maxHeight:"80vh", overflow:"auto", boxShadow:"0 20px 60px rgba(0,0,0,0.2)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <div>
            <div style={{ fontSize:18, fontWeight:700, color:"#111827", fontFamily:"'Inter',sans-serif" }}>{leagueName}</div>
            <div style={{ fontSize:12, color:"#9ca3af", fontFamily:"'Inter',sans-serif" }}>Members · sorted alphabetically</div>
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", color:"#9ca3af", fontSize:22, cursor:"pointer" }}>✕</button>
        </div>
        {loading ? <div style={{ textAlign:"center", padding:40, color:"#9ca3af", fontFamily:"'Inter',sans-serif" }}>Loading...</div> : (
          <table style={{ width:"100%", borderCollapse:"collapse" }}>
            <thead>
              <tr style={{ borderBottom:"1px solid #f3f4f6" }}>
                {["Team","Owner / Email","Credits","Bets",""].map(h=>(
                  <th key={h} style={{ padding:"8px 10px", textAlign:"left", fontSize:11, fontWeight:600, color:"#9ca3af", letterSpacing:"0.04em", fontFamily:"'Inter',sans-serif" }}>{h.toUpperCase()}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {sorted.map(m => (
                <tr key={m.id} style={{ borderBottom:"1px solid #f9fafb" }}>
                  <td style={{ padding:"10px 10px" }}>
                    <div style={{ fontSize:14, fontWeight:600, color:"#111827", fontFamily:"'Inter',sans-serif" }}>
                      {m.team_name}
                      {m.is_admin && <span style={{ marginLeft:6, fontSize:10, padding:"1px 6px", background:"#f0fdf8", color:"#3d9e7a", border:"1px solid #a7f3d0", borderRadius:4, fontWeight:700 }}>ADMIN</span>}
                    </div>
                  </td>
                  <td style={{ padding:"10px 10px" }}>
                    <div style={{ fontSize:13, color:"#374151", fontFamily:"'Inter',sans-serif" }}>{m.owner_name}</div>
                    <div style={{ fontSize:11, color:"#9ca3af", fontFamily:"'Inter',sans-serif" }}>{m.email||"—"}</div>
                  </td>
                  <td style={{ padding:"10px 10px", fontSize:14, fontWeight:700, color:"#111827", fontFamily:"'Inter',sans-serif" }}>{Number(m.credits).toLocaleString()}</td>
                  <td style={{ padding:"10px 10px", fontSize:12, color:"#6b7280", fontFamily:"'Inter',sans-serif" }}>{m.bet_count} bets · {m.pending_bets} pending</td>
                  <td style={{ padding:"10px 10px", textAlign:"right" }}>
                    {!m.is_admin && <button onClick={()=>removePlayer(m)} style={{ padding:"4px 10px", background:"#fff5f5", border:"1px solid #fecaca", borderRadius:6, color:"#dc2626", cursor:"pointer", fontSize:12, fontFamily:"'Inter',sans-serif" }}>Remove</button>}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}

function SportsModal({ league, token, onClose, onSaved }) {
  const [sports, setSports] = useState(league.sports || ["americanfootball_nfl","basketball_nba","baseball_mlb","icehockey_nhl"]);
  const [saving, setSaving] = useState(false);
  const groups = [...new Set(ALL_SPORTS.map(s=>s.group))];
  const toggle = (key) => setSports(prev => prev.includes(key) ? prev.filter(k=>k!==key) : [...prev,key]);

  const save = async () => {
    setSaving(true);
    await fetch(`${API}/superadmin/leagues/${league.id}/sports`, {
      method:"PUT", headers:{"Content-Type":"application/json", Authorization:`Bearer ${token}`},
      body:JSON.stringify({sports}),
    });
    setSaving(false); onSaved(); onClose();
  };

  return (
    <div onClick={onClose} style={{ position:"fixed", inset:0, background:"rgba(0,0,0,0.5)", display:"flex", alignItems:"center", justifyContent:"center", zIndex:300, padding:20 }}>
      <div onClick={e=>e.stopPropagation()} style={{ background:"#fff", borderRadius:16, padding:28, maxWidth:520, width:"100%", maxHeight:"80vh", overflow:"auto", boxShadow:"0 20px 60px rgba(0,0,0,0.2)" }}>
        <div style={{ display:"flex", justifyContent:"space-between", alignItems:"center", marginBottom:20 }}>
          <div>
            <div style={{ fontSize:16, fontWeight:700, color:"#111827", fontFamily:"'Inter',sans-serif" }}>{league.name}</div>
            <div style={{ fontSize:12, color:"#9ca3af", fontFamily:"'Inter',sans-serif" }}>Edit sports access</div>
          </div>
          <button onClick={onClose} style={{ background:"none", border:"none", color:"#9ca3af", fontSize:22, cursor:"pointer" }}>✕</button>
        </div>
        {groups.map(group => (
          <div key={group} style={{ marginBottom:16 }}>
            <div style={{ fontSize:11, fontWeight:600, color:"#9ca3af", marginBottom:8, fontFamily:"'Inter',sans-serif", letterSpacing:"0.04em" }}>{group.toUpperCase()}</div>
            <div style={{ display:"flex", flexWrap:"wrap", gap:6 }}>
              {ALL_SPORTS.filter(s=>s.group===group).map(sport => (
                <button key={sport.key} onClick={()=>toggle(sport.key)} style={{ padding:"5px 12px", borderRadius:8, border:"1px solid", borderColor:sports.includes(sport.key)?"#3d9e7a":"#e5e7eb", background:sports.includes(sport.key)?"#f0fdf8":"#fff", color:sports.includes(sport.key)?"#3d9e7a":"#6b7280", cursor:"pointer", fontSize:12, fontFamily:"'Inter',sans-serif" }}>
                  {sport.emoji} {sport.label}
                </button>
              ))}
            </div>
          </div>
        ))}
        <div style={{ display:"flex", gap:10, marginTop:8 }}>
          <button onClick={save} disabled={saving} style={{ flex:1, padding:11, background:"#3d9e7a", color:"#fff", border:"none", borderRadius:8, fontWeight:600, cursor:"pointer", fontFamily:"'Inter',sans-serif" }}>{saving?"Saving...":"Save Sports"}</button>
          <button onClick={onClose} style={{ flex:1, padding:11, background:"transparent", color:"#6b7280", border:"1px solid #e5e7eb", borderRadius:8, cursor:"pointer", fontFamily:"'Inter',sans-serif" }}>Cancel</button>
        </div>
      </div>
    </div>
  );
}

function SettlementPanel({ token }) {
  const [status, setStatus] = useState(null);
  const [running, setRunning] = useState(false);
  const [result, setResult] = useState(null);
  const [elimRunning, setElimRunning] = useState(false);
  const [elimResult, setElimResult] = useState(null);

  const loadStatus = async () => {
    try {
      const res = await fetch(`${API}/admin/settlement/status`, { headers:{ Authorization:`Bearer ${token}` } });
      setStatus(await res.json());
    } catch(e) {}
  };

  const runNow = async () => {
    setRunning(true); setResult(null);
    try {
      await fetch(`${API}/admin/settlement/h2h/run`, { method:"POST", headers:{ Authorization:`Bearer ${token}` } });
      const res = await fetch(`${API}/admin/settlement/run`, { method:"POST", headers:{ Authorization:`Bearer ${token}` } });
      const data = await res.json();
      setResult(data.result);
      loadStatus();
    } catch(e) {}
    setRunning(false);
  };

  const runEliminatorNow = async () => {
    setElimRunning(true); setElimResult(null);
    try {
      const res = await fetch(`${API}/admin/settlement/eliminator/run`, { method:"POST", headers:{ Authorization:`Bearer ${token}` } });
      const data = await res.json();
      setElimResult(data.result || { error: data.detail || "Failed" });
      loadStatus();
    } catch(e) {
      setElimResult({ error: "Request failed" });
    }
    setElimRunning(false);
  };

  useEffect(() => { loadStatus(); }, []);

  return (
    <div style={{ maxWidth:600 }}>
      <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(220px, 1fr))", gap:12, marginBottom:20 }}>
        <div style={{ background:"#fff", border:"1px solid #f3f4f6", borderRadius:12, padding:"16px 20px", boxShadow:"0 1px 3px rgba(0,0,0,0.06)" }}>
          <div style={{ fontSize:11, fontWeight:600, color:"#9ca3af", marginBottom:8, fontFamily:"'Inter',sans-serif", letterSpacing:"0.04em" }}>SCHEDULER STATUS</div>
          <div style={{ fontSize:18, fontWeight:700, color:status?.running?"#3d9e7a":"#ef4444", fontFamily:"'Inter',sans-serif" }}>
            {status?.running ? "● Running" : "● Stopped"}
          </div>
          {status?.current_time_et && <div style={{ fontSize:12, color:"#9ca3af", marginTop:4, fontFamily:"'Inter',sans-serif" }}>{status.current_time_et}</div>}
          {status?.in_game_hours !== undefined && <div style={{ fontSize:12, color:status.in_game_hours?"#3d9e7a":"#9ca3af", marginTop:2, fontFamily:"'Inter',sans-serif" }}>{status.in_game_hours?"Active game hours — polling every 2min":"Off-hours polling"}</div>}
        </div>
        <div style={{ background:"#fff", border:"1px solid #f3f4f6", borderRadius:12, padding:"16px 20px", boxShadow:"0 1px 3px rgba(0,0,0,0.06)" }}>
          <div style={{ fontSize:11, fontWeight:600, color:"#9ca3af", marginBottom:10, fontFamily:"'Inter',sans-serif", letterSpacing:"0.04em" }}>MANUAL TRIGGER</div>
          <button onClick={runNow} disabled={running} style={{ padding:"10px 20px", background:running?"#f9fafb":"#3d9e7a", color:running?"#9ca3af":"#fff", border:running?"1px solid #e5e7eb":"none", borderRadius:8, fontFamily:"'Inter',sans-serif", fontSize:14, fontWeight:600, cursor:running?"not-allowed":"pointer" }}>
            {running?"Running...":"⚡ Run Now"}
          </button>
          {result && <div style={{ fontSize:12, color:"#3d9e7a", marginTop:8, fontFamily:"'Inter',sans-serif" }}>Settled: {result.settled} · Pending: {result.pending}</div>}
        </div>
        <div style={{ background:"#fff", border:"1px solid #f3f4f6", borderRadius:12, padding:"16px 20px", boxShadow:"0 1px 3px rgba(0,0,0,0.06)" }}>
          <div style={{ fontSize:11, fontWeight:600, color:"#9ca3af", marginBottom:10, fontFamily:"'Inter',sans-serif", letterSpacing:"0.04em" }}>ELIMINATOR (settle picks + advance week)</div>
          <button onClick={runEliminatorNow} disabled={elimRunning} style={{ padding:"10px 20px", background:elimRunning?"#f9fafb":"#dc2626", color:elimRunning?"#9ca3af":"#fff", border:elimRunning?"1px solid #e5e7eb":"none", borderRadius:8, fontFamily:"'Inter',sans-serif", fontSize:14, fontWeight:600, cursor:elimRunning?"not-allowed":"pointer" }}>
            {elimRunning?"Running...":"🎯 Run Now"}
          </button>
          {elimResult && (elimResult.error
            ? <div style={{ fontSize:12, color:"#dc2626", marginTop:8, fontFamily:"'Inter',sans-serif" }}>{elimResult.error}</div>
            : <div style={{ marginTop:8 }}>
                <div style={{ fontSize:12, color:"#3d9e7a", fontFamily:"'Inter',sans-serif" }}>Settled: {elimResult.settled} · Advanced: {elimResult.advanced?.length || 0} league(s)</div>
                {elimResult.note && <div style={{ fontSize:11, color:"#9ca3af", marginTop:4, fontFamily:"'Inter',sans-serif" }}>{elimResult.note}</div>}
                {elimResult.skipped?.length > 0 && (
                  <div style={{ marginTop:6, padding:"8px 10px", background:"#fff5f5", border:"1px solid #fecaca", borderRadius:6 }}>
                    <div style={{ fontSize:11, fontWeight:700, color:"#dc2626", marginBottom:4, fontFamily:"'Inter',sans-serif" }}>Skipped:</div>
                    {elimResult.skipped.map((s,i) => (
                      <div key={i} style={{ fontSize:11, color:"#991b1b", fontFamily:"'Inter',sans-serif", marginBottom:2 }}>
                        {s.league_id}: {s.reason}
                        {s.games_not_done?.length > 0 && <span style={{ color:"#b91c1c" }}> ({s.games_not_done.join(", ")})</span>}
                      </div>
                    ))}
                  </div>
                )}
              </div>
          )}
        </div>
      </div>
      {status?.jobs?.length > 0 && (
        <div style={{ background:"#fff", border:"1px solid #f3f4f6", borderRadius:12, padding:20, boxShadow:"0 1px 3px rgba(0,0,0,0.06)" }}>
          <div style={{ fontSize:13, fontWeight:700, color:"#111827", marginBottom:12, fontFamily:"'Inter',sans-serif" }}>Scheduled Jobs</div>
          {status.jobs.map(job => (
            <div key={job.id} style={{ display:"flex", justifyContent:"space-between", padding:"8px 0", borderBottom:"1px solid #f9fafb", fontSize:13, fontFamily:"'Inter',sans-serif" }}>
              <span style={{ color:"#374151" }}>{job.name}</span>
              <span style={{ color:"#9ca3af" }}>Next: {job.next_run ? new Date(job.next_run).toLocaleTimeString() : "—"}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

export default function SuperAdmin({ onBack }) {
  const [view, setView] = useState("login");
  const [token, setToken] = useState(null);
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [stats, setStats] = useState(null);
  const [leagues, setLeagues] = useState([]);
  const [allBets, setAllBets] = useState([]);
  const [activeTab, setActiveTab] = useState("leagues");
  const [loading, setLoading] = useState(false);
  const [dataLoading, setDataLoading] = useState(false);
  const [memberModal, setMemberModal] = useState(null);
  const [recapSending, setRecapSending] = useState({});
  const [sportsModal, setSportsModal] = useState(null);

  const login = async () => {
    setError(""); setLoading(true);
    try {
      const res = await fetch(`${API}/auth/superadmin/login`, { method:"POST", headers:{"Content-Type":"application/json"}, body:JSON.stringify({username,password}) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.detail);
      localStorage.setItem("scraps_sa_token", data.token);
      setToken(data.token); setView("dashboard");
      loadData(data.token);
    } catch(e) { setError(e.message); }
    setLoading(false);
  };

  useEffect(() => {
    const saved = localStorage.getItem("scraps_sa_token");
    if (saved) { setToken(saved); setView("dashboard"); loadData(saved); }
  }, []);

  const loadData = async (t) => {
    const tok = t || localStorage.getItem("scraps_sa_token");
    if (!tok) return;
    setDataLoading(true);
    try {
      const headers = { Authorization:`Bearer ${tok}` };
      const [statsRes, leaguesRes, betsRes] = await Promise.all([
        fetch(`${API}/superadmin/stats`, { headers }),
        fetch(`${API}/superadmin/leagues`, { headers }),
        fetch(`${API}/superadmin/all-bets`, { headers }),
      ]);
      if (!statsRes.ok || !leaguesRes.ok) throw new Error("Auth failed");
      setStats(await statsRes.json());
      setLeagues(await leaguesRes.json());
      setAllBets(await betsRes.json());
    } catch(e) { console.error(e); }
    setDataLoading(false);
  };

  const getToken = () => localStorage.getItem("scraps_sa_token");

  const approveLeague = async (leagueId, approve) => {
    const tok = getToken();
    setLeagues(prev => prev.map(l => l.id===leagueId ? {...l,status:approve?"approved":"rejected"} : l));
    await fetch(`${API}/superadmin/leagues/${leagueId}/approve`, { method:"POST", headers:{"Content-Type":"application/json", Authorization:`Bearer ${tok}`}, body:JSON.stringify({approve}) });
    await loadData(tok);
  };

  const pauseLeague = async (leagueId, paused) => {
    const tok = getToken();
    setLeagues(prev => prev.map(l => l.id===leagueId ? {...l,paused} : l));
    await fetch(`${API}/superadmin/leagues/${leagueId}/pause`, { method:"POST", headers:{"Content-Type":"application/json", Authorization:`Bearer ${tok}`}, body:JSON.stringify({paused}) });
    await loadData(tok);
  };

  const deleteLeague = async (leagueId) => {
    if (!window.confirm("Delete this league permanently?")) return;
    const tok = getToken();
    setLeagues(prev => prev.filter(l => l.id!==leagueId));
    await fetch(`${API}/superadmin/leagues/${leagueId}`, { method:"DELETE", headers:{ Authorization:`Bearer ${tok}` } });
    await loadData(tok);
  };

  const logout = () => { localStorage.removeItem("scraps_sa_token"); setToken(null); setView("login"); };

  const statusInfo = (l) => {
    if (l.paused) return { label:"Paused", color:"#ef4444", bg:"#fff5f5", border:"#fecaca" };
    if (l.status==="approved"||l.status==="active") return { label:"Active", color:"#3d9e7a", bg:"#f0fdf8", border:"#a7f3d0" };
    if (l.status==="rejected") return { label:"Rejected", color:"#ef4444", bg:"#fff5f5", border:"#fecaca" };
    return { label:"Pending", color:"#f59e0b", bg:"#fffbeb", border:"#fcd34d" };
  };

  if (view === "login") return (
    <div style={{ minHeight:"100vh", background:"#0d1b2a", display:"flex", alignItems:"center", justifyContent:"center", fontFamily:"'Inter',sans-serif", padding:"32px 24px" }}>
      <style>{FONT}</style>
      <div style={{ background:"#fff", borderRadius:20, padding:"36px 32px", width:"100%", maxWidth:420 }}>
        <div style={{ textAlign:"center", marginBottom:24 }}>
          <img src="/scraps_logo.png" alt="Scraps" style={{ height:90, objectFit:"contain", marginBottom:12 }}/>
          <div style={{ fontSize:13, color:"#6b7280" }}>Platform Control</div>
        </div>
        <div style={{ background:"#fffbeb", border:"1px solid #fcd34d", borderRadius:10, padding:"10px 14px", marginBottom:20, textAlign:"center" }}>
          <div style={{ fontSize:13, fontWeight:600, color:"#92400e" }}>🔒 Superadmin Access</div>
          <div style={{ fontSize:12, color:"#6b7280", marginTop:3 }}>Restricted to authorized personnel only</div>
        </div>
        {error && <div style={{ background:"#fff5f5", border:"1px solid #fecaca", borderRadius:8, padding:"10px 14px", fontSize:13, color:"#dc2626", marginBottom:16 }}>{error}</div>}
        <label style={{ fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:5, letterSpacing:"0.04em" }}>USERNAME</label>
        <input value={username} onChange={e=>setUsername(e.target.value)} placeholder="Username" style={{ width:"100%", padding:"10px 14px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, marginBottom:12, outline:"none", boxSizing:"border-box", display:"block" }}/>
        <label style={{ fontSize:11, fontWeight:600, color:"#6b7280", display:"block", marginBottom:5, letterSpacing:"0.04em" }}>PASSWORD</label>
        <input type="password" value={password} onChange={e=>setPassword(e.target.value)} onKeyDown={e=>e.key==="Enter"&&login()} placeholder="Password" style={{ width:"100%", padding:"10px 14px", border:"1px solid #e5e7eb", borderRadius:8, fontSize:14, marginBottom:16, outline:"none", boxSizing:"border-box" }}/>
        <button onClick={login} disabled={loading} style={{ width:"100%", padding:12, background:"#3d9e7a", color:"#fff", border:"none", borderRadius:8, fontSize:14, fontWeight:600, cursor:"pointer", marginBottom:10 }}>
          {loading?"Signing in...":"Sign In"}
        </button>
        <button onClick={onBack} style={{ width:"100%", padding:10, background:"transparent", color:"#6b7280", border:"1px solid #e5e7eb", borderRadius:8, cursor:"pointer", fontSize:13 }}>← Back to Scraps</button>
      </div>
    </div>
  );

  const tabs = ["leagues","bets","settlement"];
  const tabLabels = { leagues:"Leagues", bets:"Bets", settlement:"Settlement" };

  return (
    <div style={{ minHeight:"100vh", background:"#1e2a3a", fontFamily:"'Inter',sans-serif" }}>
      <style>{FONT}</style>
      {sportsModal && <SportsModal league={sportsModal} token={token} onClose={()=>setSportsModal(null)} onSaved={()=>loadData()}/>}
      {memberModal && <MemberModal leagueId={memberModal.id} leagueName={memberModal.name} token={token} onClose={()=>setMemberModal(null)}/>}

      {/* Header */}
      <div style={{ background:"#0d1b2a", padding:"14px 24px", display:"flex", alignItems:"center", justifyContent:"space-between", position:"sticky", top:0, zIndex:10 }}>
        <div>
          <div style={{ display:"flex", alignItems:"center", gap:10 }}>
            <div style={{ background:"#ffffff", borderRadius:8, padding:"3px 10px", display:"inline-block" }}><img src="/scraps_logo.png" alt="Scraps" style={{ height:22, objectFit:"contain", display:"block" }}/></div>
            <span style={{ fontSize:12, color:"#6b7280", fontFamily:"'Inter',sans-serif" }}>· Superadmin</span>
          </div>
        </div>
        <div style={{ display:"flex", gap:8 }}>
          <button onClick={()=>loadData()} style={{ padding:"6px 14px", background:"transparent", border:"1px solid rgba(255,255,255,0.2)", borderRadius:6, color:"#f0f4ff", cursor:"pointer", fontSize:12 }}>{dataLoading?"Loading...":"↻ Refresh"}</button>
          <button onClick={onBack} style={{ padding:"6px 14px", background:"transparent", border:"1px solid rgba(255,255,255,0.2)", borderRadius:6, color:"#f0f4ff", cursor:"pointer", fontSize:12 }}>← App</button>
          <button onClick={logout} style={{ padding:"6px 14px", background:"transparent", border:"1px solid rgba(239,68,68,0.4)", borderRadius:6, color:"#fca5a5", cursor:"pointer", fontSize:12 }}>Logout</button>
        </div>
      </div>

      {/* Stats grid */}
      {stats && (
        <div style={{ padding:"20px 24px 0", maxWidth:1280, margin:"0 auto" }}>
          <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit, minmax(140px,1fr))", gap:10, marginBottom:20 }}>
            <StatCard label="Leagues" value={stats.total_leagues} />
            <StatCard label="Active" value={stats.approved_leagues} accent="#3d9e7a"/>
            <StatCard label="Pending" value={stats.pending_leagues} accent="#f59e0b"/>
            <StatCard label="Accounts" value={stats.total_accounts} />
            <StatCard label="Total Bets" value={stats.total_bets} />
            <StatCard label="Pending Bets" value={stats.pending_bets} accent="#f59e0b"/>
            <StatCard label="Settled" value={stats.settled_bets} />
            <StatCard label="Won" value={stats.won_bets} accent="#3d9e7a"/>
            <StatCard label="Teams" value={stats.total_teams} />
          </div>
        </div>
      )}

      {/* Tabs */}
      <div style={{ background:"#fff", borderBottom:"1px solid #f3f4f6", padding:"0 24px", display:"flex", justifyContent:"center" }}>
        {tabs.map(tab => (
          <button key={tab} onClick={()=>setActiveTab(tab)} style={{ padding:"12px 20px", background:"transparent", border:"none", borderBottom:activeTab===tab?"2px solid #3d9e7a":"2px solid transparent", color:activeTab===tab?"#3d9e7a":"#6b7280", fontFamily:"'Inter',sans-serif", fontSize:13, fontWeight:activeTab===tab?700:500, cursor:"pointer", whiteSpace:"nowrap" }}>
            {tabLabels[tab]}
          </button>
        ))}
      </div>

      {/* Content */}
      <div style={{ padding:"20px 24px", maxWidth:1280, margin:"0 auto" }}>

        {activeTab==="leagues" && (
          <div>
            {leagues.length===0 && <div style={{ textAlign:"center", padding:40, color:"#9ca3af" }}>No leagues yet</div>}
            {leagues.map(league => {
              const s = statusInfo(league);
              return (
                <div key={league.id} style={{ background:"#fff", border:"1px solid #f3f4f6", borderRadius:14, padding:"18px 20px", marginBottom:12, boxShadow:"0 1px 3px rgba(0,0,0,0.06)" }}>
                  <div style={{ display:"flex", alignItems:"flex-start", justifyContent:"space-between", marginBottom:10 }}>
                    <div style={{ flex:1, minWidth:0 }}>
                      <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:4 }}>
                        <span style={{ fontSize:16, fontWeight:700, color:"#111827", fontFamily:"'Inter',sans-serif" }}>{league.name}</span>
                        <span style={{ fontSize:11, padding:"2px 10px", borderRadius:20, background:s.bg, color:s.color, border:`1px solid ${s.border}`, fontWeight:600 }}>{s.label}</span>
                        {league.league_type && <span style={{ fontSize:11, padding:"2px 8px", borderRadius:6, background:"#f3f4f6", color:"#6b7280", fontWeight:500 }}>{league.league_type}</span>}
                      </div>
                      <div style={{ fontSize:12, color:"#9ca3af", fontFamily:"'Inter',sans-serif" }}>
                        Admin: {league.admin_name} · {league.admin_email}
                      </div>
                      {league.reason && <div style={{ fontSize:12, color:"#9ca3af", fontStyle:"italic", marginTop:2 }}>"{league.reason}"</div>}
                    </div>
                  </div>

                  {/* Stats row */}
                  <div style={{ display:"flex", gap:0, marginBottom:12, background:"#f9fafb", borderRadius:8, overflow:"hidden", border:"1px solid #f3f4f6" }}>
                    {[
                      { label:"ID", value:league.id, mono:true },
                      { label:"Invite", value:league.invite_code||"—", green:!!league.invite_code },
                      { label:"Credits", value:league.starting_credits?.toLocaleString() },
                      { label:"Members", value:league.member_count },
                      { label:"Bets", value:league.bet_count },
                    ].map((item,i) => (
                      <div key={item.label} style={{ flex:1, padding:"8px 12px", borderRight:i<4?"1px solid #f3f4f6":"none" }}>
                        <div style={{ fontSize:10, fontWeight:600, color:"#9ca3af", letterSpacing:"0.04em", marginBottom:3 }}>{item.label.toUpperCase()}</div>
                        <div style={{ fontSize:12, fontWeight:600, color:item.green?"#3d9e7a":"#374151", fontFamily:item.mono?"monospace":"'Inter',sans-serif", overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap" }}>{item.value}</div>
                      </div>
                    ))}
                  </div>

                  {/* Sports tags */}
                  {league.sports?.length > 0 && (
                    <div style={{ display:"flex", gap:5, flexWrap:"wrap", marginBottom:12 }}>
                      {league.sports.map(s => {
                        const sport = ALL_SPORTS.find(a=>a.key===s);
                        return sport ? <span key={s} style={{ fontSize:11, padding:"2px 8px", background:"#f3f4f6", borderRadius:6, color:"#6b7280" }}>{sport.emoji} {sport.label}</span> : null;
                      })}
                    </div>
                  )}

                  {/* Actions */}
                  <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
                    {league.status==="pending" && <>
                      <button onClick={()=>approveLeague(league.id,true)} style={{ padding:"6px 14px", background:"#f0fdf8", border:"1px solid #a7f3d0", borderRadius:6, color:"#3d9e7a", cursor:"pointer", fontSize:12, fontWeight:600, fontFamily:"'Inter',sans-serif" }}>✓ Approve</button>
                      <button onClick={()=>approveLeague(league.id,false)} style={{ padding:"6px 14px", background:"#fff5f5", border:"1px solid #fecaca", borderRadius:6, color:"#dc2626", cursor:"pointer", fontSize:12, fontWeight:600, fontFamily:"'Inter',sans-serif" }}>✕ Reject</button>
                    </>}
                    {(league.status==="approved"||league.status==="active") && league.league_type==="h2h" && <>
                      <button onClick={async()=>{ const tok=getToken(); const res=await fetch(`${API}/h2h/${league.id}/admin/start-league`,{method:"POST",headers:{Authorization:`Bearer ${tok}`}}); const data=await res.json(); alert(data.message||data.detail); await loadData(tok); }} style={{ padding:"6px 14px", background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:6, color:"#3b82f6", cursor:"pointer", fontSize:12, fontWeight:600, fontFamily:"'Inter',sans-serif" }}>▶ Start</button>
                      <button onClick={async()=>{ const tok=getToken(); const res=await fetch(`${API}/h2h/${league.id}/admin/advance-period`,{method:"POST",headers:{Authorization:`Bearer ${tok}`}}); const data=await res.json(); alert(data.message||data.detail); await loadData(tok); }} style={{ padding:"6px 14px", background:"#eff6ff", border:"1px solid #bfdbfe", borderRadius:6, color:"#3b82f6", cursor:"pointer", fontSize:12, fontWeight:600, fontFamily:"'Inter',sans-serif" }}>⏭ Advance</button>
                    </>}
                    {(league.status==="approved"||league.status==="active") && (!league.league_type || league.league_type==="classic") && (
                      <button disabled={!!recapSending[league.id]} onClick={async()=>{
                        if(!window.confirm(`Send the weekly recap email to every member of "${league.name}" right now?`)) return;
                        setRecapSending(prev=>({...prev,[league.id]:true}));
                        // Bug fix: this had no try/catch and no timeout — if the request
                        // errored (network blip, backend cold-start) the fetch just
                        // rejected silently. No alert, no error, button stayed clickable
                        // — from the admin's side it looked like nothing happened and
                        // there was no way to tell a slow request from a dead one.
                        //
                        // Also: the backend endpoint now kicks the actual sending off as
                        // a background task and responds right away (see main.py) instead
                        // of making this request wait on every team's email to go out —
                        // that synchronous wait was long enough for a 20+-member league
                        // that the hosting proxy would kill the connection before a
                        // response came back, which surfaced here as a bare "Failed to
                        // fetch" even though the send may have completed server-side.
                        // The timeout below is now just a safety net for a slow/dead
                        // connection, not for the email batch itself.
                        const controller = new AbortController();
                        const timeoutId = setTimeout(()=>controller.abort(), 30000);
                        try{
                          const tok=getToken();
                          const res=await fetch(`${API}/superadmin/weekly-recap/send/${league.id}`,{method:"POST",headers:{Authorization:`Bearer ${tok}`},signal:controller.signal});
                          const data=await res.json();
                          alert(res.ok?(data.message || "Recap send started."):(data.detail||"Failed to send recap"));
                        }catch(e){
                          alert(e.name==="AbortError" ? "Request timed out after 30 seconds — the server may be waking up (Render cold start), try again in a moment." : `Recap send failed: ${e.message}`);
                        }finally{
                          clearTimeout(timeoutId);
                          setRecapSending(prev=>({...prev,[league.id]:false}));
                        }
                      }} style={{ padding:"6px 14px", background:recapSending[league.id]?"#f9fafb":"#f5f3ff", border:`1px solid ${recapSending[league.id]?"#e5e7eb":"#ddd6fe"}`, borderRadius:6, color:recapSending[league.id]?"#9ca3af":"#7c3aed", cursor:recapSending[league.id]?"not-allowed":"pointer", fontSize:12, fontWeight:600, fontFamily:"'Inter',sans-serif" }}>{recapSending[league.id]?"Sending…":"📊 Send Recap"}</button>
                    )}
                    {(league.status==="approved"||league.status==="active") && (
                      <button onClick={()=>pauseLeague(league.id,!league.paused)} style={{ padding:"6px 14px", background:league.paused?"#f0fdf8":"#fff5f5", border:`1px solid ${league.paused?"#a7f3d0":"#fecaca"}`, borderRadius:6, color:league.paused?"#3d9e7a":"#dc2626", cursor:"pointer", fontSize:12, fontWeight:600, fontFamily:"'Inter',sans-serif" }}>
                        {league.paused?"▶ Unpause":"⏸ Pause"}
                      </button>
                    )}
                    {league.status==="rejected" && (
                      <button onClick={()=>approveLeague(league.id,true)} style={{ padding:"6px 14px", background:"#f0fdf8", border:"1px solid #a7f3d0", borderRadius:6, color:"#3d9e7a", cursor:"pointer", fontSize:12, fontFamily:"'Inter',sans-serif" }}>Re-approve</button>
                    )}
                    <button onClick={()=>setSportsModal(league)} style={{ padding:"6px 14px", background:"#fffbeb", border:"1px solid #fcd34d", borderRadius:6, color:"#92400e", cursor:"pointer", fontSize:12, fontFamily:"'Inter',sans-serif" }}>🏈 Sports</button>
                    <button onClick={()=>setMemberModal(league)} style={{ padding:"6px 14px", background:"#f9fafb", border:"1px solid #e5e7eb", borderRadius:6, color:"#374151", cursor:"pointer", fontSize:12, fontFamily:"'Inter',sans-serif" }}>👥 Members</button>
                    <button onClick={()=>deleteLeague(league.id)} style={{ padding:"6px 14px", background:"transparent", border:"1px solid #fecaca", borderRadius:6, color:"#ef4444", cursor:"pointer", fontSize:12, fontFamily:"'Inter',sans-serif" }}>Delete</button>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {activeTab==="settlement" && <SettlementPanel token={token}/>}

        {activeTab==="bets" && (
          <div style={{ background:"#fff", border:"1px solid #f3f4f6", borderRadius:14, overflow:"hidden", boxShadow:"0 1px 3px rgba(0,0,0,0.06)" }}>
            {allBets.length===0 && <div style={{ textAlign:"center", padding:40, color:"#9ca3af", fontFamily:"'Inter',sans-serif" }}>No bets yet</div>}
            <div style={{ overflowX:"auto" }}>
              <table style={{ width:"100%", borderCollapse:"collapse", fontSize:13 }}>
                <thead>
                  <tr style={{ borderBottom:"1px solid #f3f4f6", background:"#f9fafb" }}>
                    {["Team","League","Game","Selection","Type","Wager","To Win","Status","Result"].map(h => (
                      <th key={h} style={{ padding:"10px 12px", textAlign:"left", fontSize:11, fontWeight:600, color:"#9ca3af", letterSpacing:"0.04em", fontFamily:"'Inter',sans-serif", whiteSpace:"nowrap" }}>{h.toUpperCase()}</th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {allBets.map(bet => (
                    <tr key={bet.id} style={{ borderBottom:"1px solid #f9fafb" }}>
                      <td style={{ padding:"10px 12px", fontSize:13, color:"#374151", fontFamily:"'Inter',sans-serif" }}>{bet.team_name||bet.team_id}</td>
                      <td style={{ padding:"10px 12px", fontSize:13, color:"#374151", fontFamily:"'Inter',sans-serif" }}>{bet.league_name||bet.league_id}</td>
                      <td style={{ padding:"10px 12px", fontSize:12, color:"#6b7280", fontFamily:"'Inter',sans-serif" }}>{bet.game_name}</td>
                      <td style={{ padding:"10px 12px", fontSize:13, fontWeight:500, color:"#111827", fontFamily:"'Inter',sans-serif" }}>{bet.selection}{bet.point?` ${bet.point>0?"+":""}${bet.point}`:""}</td>
                      <td style={{ padding:"10px 12px" }}><span style={{ fontSize:11, padding:"2px 8px", background:"#eff6ff", color:"#3b82f6", borderRadius:4, fontFamily:"'Inter',sans-serif", fontWeight:600 }}>{bet.market_label}</span></td>
                      <td style={{ padding:"10px 12px", fontSize:13, fontWeight:600, color:"#111827", fontFamily:"'Inter',sans-serif" }}>{bet.wager?.toLocaleString()}</td>
                      <td style={{ padding:"10px 12px", fontSize:13, color:"#3d9e7a", fontFamily:"'Inter',sans-serif" }}>{bet.to_win?.toLocaleString()}</td>
                      <td style={{ padding:"10px 12px" }}>
                        <span style={{ fontSize:11, padding:"2px 8px", borderRadius:4, background:bet.status==="pending"?"#fffbeb":"#f0fdf8", color:bet.status==="pending"?"#92400e":"#3d9e7a", fontFamily:"'Inter',sans-serif", fontWeight:600 }}>{bet.status}</span>
                      </td>
                      <td style={{ padding:"10px 12px", fontSize:13, fontWeight:600, color:bet.result==="won"?"#3d9e7a":bet.result==="lost"?"#ef4444":"#9ca3af", fontFamily:"'Inter',sans-serif" }}>{bet.result||"—"}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
